// Types for the columns of the GenericTable component
// Change this if you want to add, remove, or modify columns shown in the tables for each model
// TODO: Put this in their own repsective folders

import { TableColumn } from "react-data-table-component";
import { ConsultingFeeComp } from "@/components/Projects/Table/ConsultingFeeComp";
import { handleDownloadDocuments } from "@/components/Projects/Table/Utils/handleDownloadDocuments";
import { ClientProps } from "@/interfaces/client_types";
import { PointOfContactProps } from "@/interfaces/point-of-contact_types";
import { AssignmentProps } from "../../../../interfaces/assignment_types";
import { EmployeeProps } from "../../../../interfaces/employee_type";
import { InvoiceProps } from "../../../../interfaces/invoices_types";
import { ProjectProps } from "../../../../interfaces/project_types";
import { RFIProps } from "../../../../interfaces/rfi_types";
import { SubmittalProps } from "../../../../interfaces/submittal_types";
import { TaskProps } from "../../../../interfaces/tasks_types";
import { TitleHeaderHyperlink } from "../../../Dashboard/UI/Cards/Utils/TitleHeaderHyperlink";
import { openFolder } from "../../../misc";
import { InteractableCAS } from "../UI/ColumnComps/InteractableCAS";
import { InteractableSize } from "../UI/ColumnComps/InteractableSize";
import { InteractableStatus } from "../UI/ColumnComps/InteractableStatus";
import { InvoiceStatus } from "./SelectorDivs/Invoice";

export const PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	{
		name: "Project ID",
		width: "10rem",
		id: "project_id",
		selector: (row: ProjectProps) => row.project_id ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<div
				className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline"
				onClick={() => openFolder(row.folder_location || "")}
			>
				{row.project_id?.split("-")[0]}
			</div>
		),
	},
	{
		name: "Project Name",
		id: "project_name",
		selector: (row: ProjectProps) => row.project_name,
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_name}</div>,
	},
	// { name: "Download Files", id: "download_files", cell: (row: ProjectProps) => <div className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline" onClick={() => openFolder(row.folder_location || "")}>Download</div> },
	{
		name: "Client Name",
		id: "client_name",
		selector: (row: ProjectProps) => row.client?.name ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.client?.name}</div>,
	},
	{
		name: "Manager",
		id: "manager",
		selector: (row: ProjectProps) => row.manager?.name ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.manager?.name}</div>,
	},
	{
		name: "Status",
		id: "status",
		selector: (row: ProjectProps) => row.status ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<InteractableStatus
				status={row.status ?? "N/A"}
				project_id={row.project_id ?? ""}
			/>
		),
		width: "10rem",
	},
	{
		name: "Latest Invoice",
		id: "latest_invoice",
		selector: (row: ProjectProps) =>
			row.latest_invoice?.payment_amount ?? "N/A",
		cell: (row: ProjectProps) => <InvoiceStatus row={row} />,
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) =>
					row.latest_invoice?.payment_status === "Sent",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: ProjectProps) =>
					row.latest_invoice?.payment_status === "Pending",
				style: {
					backgroundColor: "var(--status-invoice-pending)",
				},
			},
			{
				when: (row: ProjectProps) => row.latest_invoice === null,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		sortable: true,
		width: "10rem",
	},
	{
		name: "Size (sqft)",
		id: "project_size",
		selector: (row: ProjectProps) => row.project_size ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<InteractableSize
				size={row.project_size}
				project_id={row.project_id ?? ""}
			/>
		),
		width: "10rem",
	},
	{
		name: "Proposal Sent",
		id: "proposal_sent",
		selector: (row: ProjectProps) => (row.proposal_sent ? "Yes" : "No"),
		sortable: true,
		cell: (row: ProjectProps) => (
			<div className="">{row.proposal_sent ? "Yes" : "No"}</div>
		),
		width: "10rem",
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) => row.proposal_sent === true,
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: ProjectProps) => row.proposal_sent === false,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
	},
];

export const CAS_PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	...PROJECT_COLUMNS,
	{
		name: "Construction Admin",
		id: "construction_admin_services",
		selector: (row: ProjectProps) => row.construction_admin_services ?? "No",
		sortable: true,
		cell: (row: ProjectProps) => (
			<InteractableCAS
				cas={row.construction_admin_services}
				project_id={row.project_id ?? ""}
			/>
		),
		width: "10rem",
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) =>
					row.construction_admin_services === "Completed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: ProjectProps) => row.construction_admin_services === "Yes",
				style: {
					backgroundColor: "var(--status-review)",
				},
			},
		],
	},
];

export const MINI_CA_PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	{
		name: "Project ID",
		width: "10rem",
		id: "project_id",
		selector: (row: ProjectProps) => row.project_id ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<div
				className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline"
				onClick={() => openFolder(row.folder_location || "")}
			>
				{row.project_id?.split("-")[0]}
			</div>
		),
	},
	{
		name: "Project Name",
		id: "project_name",
		selector: (row: ProjectProps) => row.project_name,
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_name}</div>,
	},
	{
		name: "Construction Admin",
		id: "construction_admin_services",
		selector: (row: ProjectProps) => row.construction_admin_services ?? "No",
		sortable: true,
		cell: (row: ProjectProps) => (
			<InteractableCAS
				cas={row.construction_admin_services}
				project_id={row.project_id ?? ""}
			/>
		),
	},
];

export const MINI_PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	{
		name: "Project ID",
		width: "10rem",
		id: "project_id",
		selector: (row: ProjectProps) => row.project_id ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<div
				className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline"
				onClick={() => openFolder(row.folder_location || "")}
			>
				{row.project_id?.split("-")[0]}
			</div>
		),
	},
	{
		name: "Project Name",
		id: "project_name",
		selector: (row: ProjectProps) => row.project_name,
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_name}</div>,
	},
];

export const CLIENT_PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	{
		name: "Project ID",
		width: "10rem",
		id: "project_id",
		selector: (row: ProjectProps) => row.project_id ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div>{row.project_id?.split("-")[0]}</div>,
	},
	{
		name: "Download Files",
		id: "download_files",
		width: "10rem",
		cell: (row: ProjectProps) => (
			<div
				className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline"
				onClick={() => handleDownloadDocuments(row.project_id ?? "")}
			>
				Download
			</div>
		),
	},
	{
		name: "Project Name",
		id: "project_name",
		selector: (row: ProjectProps) => row.project_name,
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_name}</div>,
	},
	{
		name: "City",
		id: "city",
		selector: (row: ProjectProps) => row.city ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.city}</div>,
	},
];

export const FINANCE_PROJECT_COLUMNS: TableColumn<ProjectProps>[] = [
	{
		name: "Project ID",
		width: "10rem",
		id: "project_id",
		selector: (row: ProjectProps) => row.project_id ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => (
			<div
				className="text-blue-500 cursor-pointer hover:text-blue-600 text-underline"
				onClick={() => openFolder(row.folder_location || "")}
			>
				{row.project_id?.split("-")[0]}
			</div>
		),
	},
	{
		name: "Project Name",
		id: "project_name",
		selector: (row: ProjectProps) => row.project_name,
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_name}</div>,
	},
	{
		name: "Client Name",
		id: "client_name",
		selector: (row: ProjectProps) => row.client?.name ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.client?.name}</div>,
	},
	{
		name: "Manager",
		id: "manager",
		selector: (row: ProjectProps) => row.manager?.name ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.manager?.name}</div>,
	},
	{
		name: "Consulting Fee (Click to Edit)",
		id: "consulting_fee",
		selector: (row: ProjectProps) => row.consulting_fee ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <ConsultingFeeComp project={row} />,
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) =>
					row.consulting_fee && row.consulting_fee > 0 ? false : true,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		width: "20rem",
	},
	{
		name: "Status",
		id: "status",
		selector: (row: ProjectProps) => row.status ?? "N/A",
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) => row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
			{
				when: (row: ProjectProps) => row.status === "Hold",
				style: {
					backgroundColor: "var(--status-hold)",
				},
			},
			{
				when: (row: ProjectProps) => row.status === "Review",
				style: {
					backgroundColor: "var(--status-review)",
				},
			},
			{
				when: (row: ProjectProps) => row.status === "Completed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
		],
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.status}</div>,
		width: "10rem",
	},
	{
		name: "Latest Invoice",
		id: "latest_invoice",
		selector: (row: ProjectProps) =>
			row.latest_invoice?.payment_amount ?? "N/A",
		cell: (row: ProjectProps) => <InvoiceStatus row={row} />,
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) =>
					row.latest_invoice?.payment_status === "Sent",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: ProjectProps) =>
					row.latest_invoice?.payment_status === "Pending",
				style: {
					backgroundColor: "var(--status-invoice-pending)",
				},
			},
			{
				when: (row: ProjectProps) => row.latest_invoice === null,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		sortable: true,
		width: "10rem",
	},
	{
		name: "Size (sqft)",
		id: "project_size",
		selector: (row: ProjectProps) => row.project_size ?? "N/A",
		sortable: true,
		cell: (row: ProjectProps) => <div className="">{row.project_size}</div>,
		width: "10rem",
	},
	{
		name: "Proposal Sent",
		id: "proposal_sent",
		selector: (row: ProjectProps) => (row.proposal_sent ? "Yes" : "No"),
		sortable: true,
		cell: (row: ProjectProps) => (
			<div className="">{row.proposal_sent ? "Yes" : "No"}</div>
		),
		width: "10rem",
		conditionalCellStyles: [
			{
				when: (row: ProjectProps) => row.proposal_sent === true,
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: ProjectProps) => row.proposal_sent === false,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
	},
];

export const INVOICE_COLUMNS: TableColumn<InvoiceProps>[] = [
	{
		name: "Date Created",
		id: "invoice_date",
		selector: (row: InvoiceProps) =>
			new Date(row.invoice_date).toLocaleDateString() ?? "N/A",
		sortable: true,
		width: "10rem",
	},
	{
		name: "Project ID",
		id: "project_id",
		selector: (row: InvoiceProps) => row.project ?? "N/A",
		sortable: true,
	},
	{
		name: "Project",
		id: "project_name",
		selector: (row: InvoiceProps) => row.project_name ?? "N/A",
		sortable: true,
	},
	{
		name: "Payment Amount",
		id: "payment_amount",
		selector: (row: InvoiceProps) => row.payment_amount + "%",
		sortable: true,
	},
	{
		name: "Sent By",
		id: "user_sent_by_name",
		selector: (row: InvoiceProps) => row.user_sent_by_name ?? "N/A",
		sortable: true,
	},
	{
		name: "Completed At",
		id: "completed_at",
		selector: (row: InvoiceProps) =>
			row.completed_at
				? new Date(row.completed_at + "T00:00:00").toLocaleDateString()
				: "N/A",
		sortable: true,
	},
	{
		name: "Notes",
		id: "notes",
		selector: (row: InvoiceProps) => row.notes ?? "N/A",
		sortable: true,
	},

	{
		name: "Payment Status",
		id: "payment_status",
		selector: (row: InvoiceProps) => row.payment_status ?? "N/A",
		conditionalCellStyles: [
			{
				when: (row: InvoiceProps) => row.payment_status === "Sent",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: InvoiceProps) => row.payment_status === "Pending",
				style: {
					backgroundColor: "var(--status-pending)",
				},
			},
		],
		sortable: true,
	},
	{
		name: "Sent to Quickbooks",
		id: "is_sent_to_quickbooks",
		selector: (row: InvoiceProps) => (row.is_sent_to_quickbooks ? "Yes" : "No"),
		conditionalCellStyles: [
			{
				when: (row: InvoiceProps) => row.is_sent_to_quickbooks === true,
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: InvoiceProps) => row.is_sent_to_quickbooks === false,
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		sortable: true,
	},
];

export const SUBMITTAL_COLUMNS: TableColumn<SubmittalProps>[] = [
	{
		name: "Project",
		id: "project",
		selector: (row: SubmittalProps) => row.project_name ?? "N/A",
		sortable: true,
		cell: (row: SubmittalProps) => (
			<TitleHeaderHyperlink
				title={row.project_name ?? "N/A"}
				folder_location={row.parent_project_folder_location ?? ""}
			/>
		),
	},
	{
		name: "Date Received",
		id: "created_date",
		selector: (row: SubmittalProps) =>
			new Date(row.created_date + "T00:00:00").toLocaleDateString() ?? "N/A",
		sortable: true,
		width: "10rem",
	},
	{
		name: "Log Out Date",
		id: "completed_at",
		selector: (row: SubmittalProps) =>
			row.completed_at
				? new Date(
						row.completed_at.split("T")[0] + "T00:00:00",
					).toLocaleDateString()
				: "N/A",
		sortable: true,
		width: "10rem",
	},
	{
		name: "Days Old",
		id: "days_old",
		selector: (row) =>
			row.days_old !== undefined ? row.days_old.toString() : "N/A",
		sortable: true,
		conditionalCellStyles: [
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old <= 3 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old > 3 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-review)",
				},
			},
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old > 6 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		width: "7rem",
	},
	{
		name: "Description",
		id: "sub_description",
		selector: (row: SubmittalProps) => row.sub_description ?? "N/A",
		sortable: true,
	},
	{
		name: "#",
		id: "sub_number",
		selector: (row: SubmittalProps) => row.sub_number ?? "N/A",
		sortable: true,
		width: "80px",
	},
	{
		name: "Category",
		id: "category",
		selector: (row: SubmittalProps) => row.category ?? "N/A",
		sortable: true,
		width: "10rem",
	},
	{
		name: "Status",
		id: "status",
		selector: (row: SubmittalProps) => row.status ?? "N/A",
		conditionalCellStyles: [
			{
				when: (row: SubmittalProps) => row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
			{
				when: (row: SubmittalProps) => row.status === "Closed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
		],
		sortable: true,
		width: "10rem",
	},
];

export const TASK_COLUMNS: TableColumn<TaskProps>[] = [
	{
		name: "Date Created",
		width: "10rem",
		id: "date_created",
		selector: (row: TaskProps) =>
			row.date_created
				? new Date(row.date_created + "T00:00:00").toLocaleDateString()
				: "N/A",
		sortable: true,
	},
	{
		name: "Title",
		id: "title",
		selector: (row: TaskProps) => row.title,
		sortable: true,
	},
	{
		name: "Assigned By",
		id: "assigned_by",
		selector: (row: TaskProps) => row.assigned_by?.split("|")[0] ?? "N/A",
		sortable: true,
	}, // Uses the __str__ representation of the employee object
	{
		name: "Assigned To",
		id: "assigned_to",
		selector: (row: TaskProps) => row.assigned_to?.split("|")[0] ?? "N/A",
		sortable: true,
	}, // Uses the __str__ representation of the employee object
	{
		name: "Project",
		id: "project_id",
		selector: (row: TaskProps) => row.project_id.split("|")[1],
		sortable: true,
	}, // Uses the __str__ representation of the project object (Yeah I don't lke this either)
	{
		name: "Status",
		id: "status",
		selector: (row: TaskProps) => row.status,
		conditionalCellStyles: [
			{
				when: (row: TaskProps) => row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
			{
				when: (row: TaskProps) => row.status === "Closed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row: TaskProps) => row.status === "Cancelled",
				style: {},
			},
		],
		sortable: true,
	},
	{
		name: "Priority",
		id: "priority",
		selector: (row: TaskProps) => row.priority,
		conditionalCellStyles: [
			{
				when: (row: TaskProps) => row.priority === "Urgent",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		maxWidth: "20px",
	},
];

export const RFI_COLUMNS: TableColumn<RFIProps>[] = [
	{
		name: "Project",
		id: "project",
		selector: (row) => row.project_name || "N/A",
		sortable: true,
		cell: (row: RFIProps) => (
			<TitleHeaderHyperlink
				title={row.project_name ?? "N/A"}
				folder_location={row.parent_project_folder_location ?? ""}
			/>
		),
	},
	{
		name: "Date Received",
		width: "10rem",
		id: "date_received",
		selector: (row) =>
			new Date(row.date_received + "T00:00:00").toLocaleDateString() ?? "N/A",
		sortable: true,
	},
	{
		name: "Log Out Date",
		id: "sent_out_date",
		selector: (row: RFIProps) =>
			row.sent_out_date
				? new Date(
						row.sent_out_date.split("T")[0] + "T00:00:00",
					).toLocaleDateString()
				: "N/A",
		sortable: true,
		width: "10rem",
	},
	{
		name: "Days Old",
		id: "days_old",
		selector: (row) =>
			row.days_old !== undefined ? row.days_old.toString() : "N/A",
		sortable: true,
		conditionalCellStyles: [
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old <= 3 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old > 3 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-review)",
				},
			},
			{
				when: (row) =>
					row.days_old !== undefined &&
					row.days_old > 6 &&
					row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
		],
		width: "7rem",
	},
	{
		name: "Description",
		id: "description",
		selector: (row) => row.description ?? "N/A",
		sortable: true,
	},
	{
		name: "#",
		id: "RFI_number",
		selector: (row) => row.RFI_number || "N/A",
		sortable: true,
		width: "100px",
	},
	{
		name: "Created By",
		id: "created_by",
		selector: (row) => (row.created_by ? row.created_by.name : "N/A"),
		sortable: true,
	},
	{
		name: "Assigned To",
		id: "assigned_to",
		selector: (row) => (row.assigned_to ? row.assigned_to.name : "N/A"),
		sortable: true,
	},
	{
		name: "Type",
		id: "type",
		selector: (row) => row.category,
		sortable: true,
		width: "10rem",
	},
	{
		name: "Status",
		id: "status",
		selector: (row) => row.status,
		conditionalCellStyles: [
			{
				when: (row: RFIProps) => row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
			{
				when: (row: RFIProps) => row.status === "Closed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
		],
		sortable: true,
		width: "10rem",
	},
];

export const EMPLOYEE_COLUMNS: TableColumn<EmployeeProps>[] = [
	{
		name: "Date Joined",
		id: "date_joined",
		selector: (row) =>
			row.date_joined
				? new Date(row.date_joined + "T00:00:00").toLocaleDateString()
				: "N/A",
		sortable: true,
	},
	{ name: "Name", id: "name", selector: (row) => row.name, sortable: true },
	{ name: "Email", id: "email", selector: (row) => row.email, sortable: true },
	{ name: "Role", id: "role", selector: (row) => row.role, sortable: true },
];

export const ASSIGNMENT_COLUMNS: TableColumn<AssignmentProps>[] = [
	{
		name: "Created At",
		id: "created_at",
		selector: (row) =>
			row.created_at
				? new Date(row.created_at + "T00:00:00").toLocaleDateString()
				: "N/A",
		sortable: true,
	},
	{ name: "Title", id: "title", selector: (row) => row.title, sortable: true },
	{
		name: "Assigned To",
		id: "assigned_to",
		selector: (row) => row.assigned_to,
		sortable: true,
	},
	{
		name: "Assigned By",
		id: "assigned_by",
		selector: (row) => row.assigned_by,
		sortable: true,
	},
	{
		name: "Status",
		id: "status",
		selector: (row: AssignmentProps) => row.status,
		conditionalCellStyles: [
			{
				when: (row: AssignmentProps) => row.status === "Active",
				style: {
					backgroundColor: "var(--status-active)",
				},
			},
			{
				when: (row: AssignmentProps) => row.status === "Closed",
				style: {
					backgroundColor: "var(--status-completed)",
				},
			},
		],
		sortable: true,
	},
];

export const CLIENT_COLUMNS: TableColumn<ClientProps>[] = [
	{ name: "Name", id: "name", selector: (row) => row.name, sortable: true },
	{
		name: "Email",
		id: "email",
		selector: (row) => row.email || "N/A",
		sortable: true,
	},
	{
		name: "Phone Number",
		id: "phone_number",
		selector: (row) => row.phone_number || "N/A",
		sortable: true,
	},
	{
		name: "City",
		id: "city",
		selector: (row) => row.city || "N/A",
		sortable: true,
	},
	{
		name: "State",
		id: "state",
		selector: (row) => row.state || "N/A",
		sortable: true,
	},
	{
		name: "Postal Code",
		id: "postal_code",
		selector: (row) => row.postal_code || "N/A",
		sortable: true,
	},
	{
		name: "Project Count",
		id: "client_projects_count",
		selector: (row) => row.client_projects_count ?? "0",
		sortable: true,
	},
];

export const POINT_OF_CONTACT_COLUMNS: TableColumn<PointOfContactProps>[] = [
	{ name: "Name", id: "name", selector: (row) => row.name, sortable: true },
	{
		name: "Email",
		id: "email",
		selector: (row) => row.email || "N/A",
		sortable: true,
	},
	{
		name: "Phone Number",
		id: "phone_number",
		selector: (row) => row.phone_number || "N/A",
		sortable: true,
	},
	{
		name: "Assigned Client",
		id: "assigned_client",
		selector: (row) => row.assigned_client?.name ?? "N/A",
		sortable: true,
	},
];
